import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

interface Props {
  children: React.ReactNode;
  onDismiss: () => void;
}

export const Error = ({ children, onDismiss }: Props) => {
  return (
    <div className="grid grid-cols-[minmax(auto,_1200px)] items-center justify-center bg-surface-3">
      <div className="grid grid-cols-[max-content_max-content] items-center justify-end gap-x1 px-x2">
        {children}
        <button onClick={onDismiss}>
          <CrossSolid fill="white" aria-label="Dismiss error" />
        </button>
      </div>
    </div>
  );
};
